// Datenformat des PIPR-Charts.
//
// ZEIT: Alle Zeitpunkte sind Unix-Sekunden in UTC. Es gibt keine Datums-Strings
// und keine implizite Zeitzonenkonvention im Transportformat. Umgerechnet wird
// erst beim Rendern, dann in die Zone des Browsers.
//
// RATEN: Basispunkte. 450 = 4,50 %. Der Anchor ist ganzzahlig, die implizite
// Rate darf Nachkommastellen haben.
//
// WAHRSCHEINLICHKEITEN: Promille als Ganzzahl. 720 = 72,0 %.
//
// ANCHOR UND PENDING: `anchorBp` ist der geltende Satz, `pendingBp` ein bereits
// beschlossener, aber noch nicht wirksamer Schritt. Für jeden Tag gilt
// implied = anchor + pending + Erwartung. Bei der Fed ist pending immer 0, bei
// der EZB für etwa eine Woche nach jedem Beschluss mit Änderung.

export type Lang = "de" | "en";
export type Bank = "fed" | "ecb";

export const BANKS: Bank[] = ["fed", "ecb"];

export const FLAG_STALE = 1;
export const FLAG_LOW_COVERAGE = 2;
export const FLAG_CARRIED = 4;
export const FLAG_PROVISIONAL = 8;

export interface Meeting {
    /** Zeitpunkt der Zinsentscheidung, Unix-Sekunden UTC */
    decisionTs: number;
    /** realisierte Änderung in bp; null, solange das Meeting in der Zukunft liegt */
    decidedBp: number | null;
}

export interface PiprHistory {
    /**
     * Zeitpunkt jeder Tagesbeobachtung, Unix-Sekunden UTC, aufsteigend.
     * Das ist der Tages-Cut um 00:00 UTC. Der Abstand wird explizit
     * mitgeliefert statt hochgerechnet.
     */
    ts: number[];
    n: number;
    /** Bin-Deltas in bp, aufsteigend, z. B. [-50, -25, 0, 25, 50] */
    deltas: number[];
    anchorBp: number[];
    /** beschlossen, noch nicht wirksam; 0 außerhalb des Fensters */
    pendingBp: number[];
    impliedBp: number[];
    /** Wahrscheinlichkeit je Tag und Bin, Promille */
    p: number[][];
    /** Index des an diesem Tag bepreisten Meetings in `meetings`; -1 = keines */
    meetingIdx: number[];
    /** Qualitäts-Bitmaske, 0 = sauber */
    flags: number[];
}

export interface ForwardMeeting {
    decisionTs: number;
    p: number[];
    /** erwartete Rate nach diesem Meeting, bp */
    rateBp: number;
    /** erwartete Rate vor diesem Meeting; Basis für die Bin-Niveaus, bp */
    baseBp: number;
}

export interface PiprForward {
    /** Zeitpunkt des Snapshots, Unix-Sekunden UTC */
    asofTs: number;
    anchorBp: number;
    pendingBp: number;
    /** null, solange pendingBp 0 ist */
    pendingAnnouncedTs: number | null;
    /** Mitternacht UTC des Wirksamkeitstags; null, solange pendingBp 0 ist */
    pendingEffectiveTs: number | null;
    deltas: number[];
    meetings: ForwardMeeting[];
}

export interface PiprBundle {
    schemaVersion: number;
    methodologyVersion: string;
    bank: Bank;
    /** Nur Herkunftsangabe für die Anzeige, keine Rechenvorschrift */
    cutTime: string;
    cutTz: string;
    /** Unix-Sekunden UTC */
    generatedTs: number;
    meetings: Meeting[];
    history: PiprHistory;
    forward: PiprForward;
}

/** Vom Client unterstützte Schema-Version. Bei Abweichung wird nicht gerendert. */
export const SUPPORTED_SCHEMA = 2;